<template>
    <div>
        <el-form :inline="true" :model="formInline"  class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item>
                <el-input v-model="formInline.scrollName" placeholder="轮播图名称" style="width:220px"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
                <el-button type="success" @click="handleAdd">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="getMallScrollPicList" stripe border center :size="GCONFIG.styleTableSize"  v-loading="loading">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="platformIdName" label="网站类型"></el-table-column>
            <el-table-column prop="picTypeName" label="栏目" ></el-table-column>
            <el-table-column prop="scrollName" label="名称" ></el-table-column>
            <el-table-column prop="scrollSummary" label="摘要"></el-table-column>
            <el-table-column prop="statusName" label="状态"></el-table-column>
            <el-table-column prop="dateFormat" label="创建时间"></el-table-column>
            <el-table-column label="操作" fixed="right" width="160">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="handleEdit(scope.row)">修改</el-button>
                    <el-button type="success" size="mini" @click="handleEditPic(scope.row)">轮播图</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="管理" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="网站类型">
                    <el-select v-model="form.platformId">
                        <el-option
                                v-for="item in getPlatFormList"
                                :key="item.platformId"
                                :label="item.platformName"
                                :value="item.platformId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="频道">
                    <el-select v-model="form.picType">
                        <el-option
                                v-for="item in getScrollPicType"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="form.status">
                        <el-option
                                v-for="item in statusList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="名称">
                    <el-input v-model="form.scrollName" ></el-input>
                </el-form-item>
                <el-form-item label="摘要">
                    <el-input v-model="form.scrollSummary"  ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateOrSaveScrollPic(form)">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog  :visible.sync="dialogFormVisiblePic" center :fullscreen="true">
            <el-form :inline="true" :model="detailListForm" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
                <el-form-item label="可用状态">
                    <el-select v-model="detailListForm.enabled">
                        <el-option
                                v-for="item in enabledList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>

                    <el-button type="primary" @click="getListDetail">查询</el-button>
                    <el-button type="success" @click="handleAddDetail">新增</el-button>
                    <el-button type="warning" @click="dialogFormVisiblePic = false">关闭</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="getMallScrollPicDetailList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading1" >
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="picurl" label="图片路径" >
                    <template  slot-scope="scope">
                        <img :src="scope.row.allpicurl" width="120" height="80" class="head_pic"/>
                    </template>
                </el-table-column>
                <el-table-column prop="url" label="跳转URL" width="200px"></el-table-column>
                <el-table-column prop="summary" label="摘要"></el-table-column>
                <el-table-column prop="sort" label="排序"></el-table-column>
                <el-table-column prop="scrollType" :formatter="convertName1" label="类型"></el-table-column>
                <el-table-column prop="userType" :formatter="convertName2" label="用户类型"></el-table-column>
                <el-table-column prop="status" :formatter="convertName3" label="状态"></el-table-column>
                <el-table-column prop="beginTime" label="开始时间"></el-table-column>
                <el-table-column prop="endTime" label="结束时间"></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" fixed="right" width="80px">
                    <template slot-scope="scope">
                        <el-button type="primary" v-if="scope.row.scrollDetailid != 565 && scope.row.scrollDetailid != 567" size="mini" @click="handleEditDetail(scope.row)">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="detailListForm.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="detailListForm.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="detailListForm.recordsTotal">
                </el-pagination>
            </div>

            <el-dialog title="管理轮播图" :visible.sync="dialogFormVisiblePicDetail" center>
                <el-form :model="formDetail" label-width="120px">
                    <el-form-item label="用户类型">
                        <el-select v-model="formDetail.userType">
                            <el-option
                                    v-for="item in userTypeList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="会员类型">
                        <el-select v-model="formDetail.scrollType">
                            <el-option
                                    v-for="item in vipTypeList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="formDetail.status">
                            <el-option
                                    v-for="item in statusList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="名称">
                        <el-input v-model="formDetail.name" ></el-input>
                    </el-form-item>
                    <el-form-item label="图片URL">
                        <el-button @click="selectUpload">上传图片</el-button>
<!--                        <uploadComponents @showSelectPic="showSelectPic" v-model="formDetail.picurl" :selectImages="formDetail.allpicurl" @on-result-change="val=> formDetail.allpicurl=val"></uploadComponents>-->
                    </el-form-item>
                    <el-form-item label="跳转URL">
                        <el-input v-model="formDetail.url"  ></el-input>
                    </el-form-item>
                    <el-form-item label="描述">
                        <el-input v-model="formDetail.summary" ></el-input>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input-number v-model="formDetail.sort" :min="1" :max="10000"   label="排序"></el-input-number>
                    </el-form-item>
                    <el-form-item label="开始日期">
                        <el-date-picker
                                v-model="formDetail.beginTime"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束日期">
                        <el-date-picker
                                v-model="formDetail.endTime"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisiblePicDetail = false">取 消</el-button>
                    <el-button type="primary" @click="updateOrSaveScrollPicDetail()">确 定</el-button>
                </div>
            </el-dialog>
            <picDialog :picType="activeNo"></picDialog>

        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getScrollPicType, getMallScrollPicList, updateOrSaveScrollPic,getPlatFormList,updateOrSaveScrollPicDetail,getMallScrollPicDetailList} from '../../api/api'
    import uploadComponents from '@/components/upload';
    import picDialog from '@/components/pic_dialog/pic_list'



    //定义组件
    export default {
        data() {
            return {
                getMallScrollPicList: [],
                getMallScrollPicDetailList:[],
                getScrollPicType:[],
                getPlatFormList:[],
                statusList: [{value: 1, name: '启用'}, {value: 0, name: '禁用'}],
                userTypeList: [{value: 0, name: '全部'}, {value: 1, name: '新用户'}, {value: 2, name: '老用户'}],
                vipTypeList: [{value: 0, name: '全部'}, {value: 1, name: '会员'}, {value: 2, name: '非会员'}],
                enabledList:[{value:0,name:'全部状态'},{value:1,name:'在线'},{value:2,name:'即将可用'},{value:3,name:'不可用'}],
                loading: true,
                loading1: true,
                dialogFormVisible: false,
                dialogFormVisiblePic:false,
                dialogFormVisiblePicDetail:false,
                form: {
                    "scrollId":"",
                    "picType": 1,
                    "status": 1,
                    "scrollName": "",
                    "scrollSummary": "",
                    "platformId": ""
                },
                detailListForm:{
                    scrollId:"",
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                    enabled:0
                },
                formDetail: {
                    "scrollDetailid":"",
                    "status":1,
                    "sort": 1,
                    "name": "",
                    "picurl": "",
                    "url": "",
                    "summary": "",
                    "scrollType": 0,
                    "userType": 0,
                    "beginTime": "",
                    "endTime": "",
                    "allpicurl":""
                },
                formInline:{
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                    enabled:0,
                    scrollName:"",

                },
                activeNo:''
            }
        },
        components:{
            uploadComponents,picDialog
        },
        //挂载时候执行
        mounted() {
            getScrollPicType({}).then((res) => {
                this.getScrollPicType = res.data.value;
            })
            getPlatFormList({}).then((res) => {
                this.getPlatFormList = res.data.value;
            })
            this.getList();
        },
        methods: {
            //定义查询方法
            getList() {
                this.loading = true;
                getMallScrollPicList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getMallScrollPicList = res.data.value.list;
                        this.formInline.recordsTotal = res.data.value.total;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleAdd() {
                this.dialogFormVisible = true;
                this.form={
                    "scrollId":"",
                    "picType": 1,
                    "status": 1,
                    "scrollName": "",
                    "scrollSummary": "",
                    "platformId": this.getPlatFormList[0].platformId
                }
            },
            handleEdit(row) {
                this.dialogFormVisible = true;
                this.form={
                    "scrollId":row.scrollId,
                    "picType": row.picType,
                    "status": row.status,
                    "scrollName": row.scrollName,
                    "scrollSummary": row.scrollSummary,
                    "platformId": row.platformId
                }
            },
            updateOrSaveScrollPic(form) {
                const loading = this.$loading(this.GCONFIG.loadingParam);
                updateOrSaveScrollPic(form).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleEditPic(row){
                this.$router.push({path:'/scrollpic/detail/:id',name: 'scrollpicDetail',params:{id:row.scrollId}})

                this.dialogFormVisiblePic = true;
                this.detailListForm.scrollId=row.scrollId;
                this.getListDetail();
            },
            convertName1(row, column, cellValue, index){
                if(cellValue==1){
                    return "会员";
                }else if(cellValue==2){
                    return "非会员";
                }else{
                    return "全部";
                }
            },
            convertName2(row, column, cellValue, index){
                if(cellValue==1){
                    return "新用户";
                }else if(cellValue==2){
                    return "老用户";
                }else{
                    return "全部";
                }
            },
            convertName3(row, column, cellValue, index){
                if(cellValue==1){
                    return "可用";
                }else{
                    return "禁用";
                }
            },
            getListDetail() {
                this.loading1 = true;
                getMallScrollPicDetailList(this.detailListForm).then((res) => {
                    this.loading1 = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getMallScrollPicDetailList = res.data.value.list;
                        this.detailListForm.recordsTotal = res.data.value.total;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange1(val) {
                this.detailListForm.pageSize = val;
                this.getListDetail()
            },
            handleCurrentChange1(val) {
                this.detailListForm.currentPage = val;
                this.getListDetail()
            },
            handleAddDetail(row){
                this.dialogFormVisiblePicDetail=true;
                this.formDetail= {
                    "scrollId":this.detailListForm.scrollId,
                    "scrollDetailid":"",
                    "status":1,
                    "sort": 1,
                    "name": "",
                    "picurl": "",
                    "url": "",
                    "summary": "",
                    "scrollType": 0,
                    "userType": 0,
                    "beginTime": "",
                    "endTime": ""
                }
            },
            handleEditDetail(row){
                this.dialogFormVisiblePicDetail=true;
                this.formDetail= {
                    "scrollId":row.scrollId,
                    "scrollDetailid":row.scrollDetailid,
                    "status":row.status,
                    "sort": row.sort,
                    "name": row.name,
                    "picurl": row.picurl,
                    "url": row.url,
                    "summary": row.summary,
                    "scrollType": row.scrollType,
                    "userType": row.userType,
                    "beginTime": row.beginTime,
                    "endTime": row.endTime,
                    "allpicurl":row.allpicurl,
                }
            },
            updateOrSaveScrollPicDetail() {
                const loading = this.$loading(this.GCONFIG.loadingParam);
                updateOrSaveScrollPicDetail(this.formDetail).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getListDetail();
                        this.dialogFormVisiblePicDetail = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            showSelectPic(obj){
                console.log('xuan',obj)
                this.dialogFormVisiblePicDetail = obj
            },
            selectUpload(){
                this.dialogFormVisiblePicDetail = false
                this.$store.commit('SET_PIC_DIALOG',true)

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/scrollpic/scrollpic.vue